import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../shared/SafeIcon';

export default function WelcomeView({ onStart }) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-white relative overflow-hidden">
      {/* Brand-aligned decorative elements */}
      <div className="absolute top-[-20%] left-[-10%] w-[60%] h-[60%] rounded-full bg-purple-50 blur-[120px] opacity-60" />
      <div className="absolute bottom-[-20%] right-[-10%] w-[60%] h-[60%] rounded-full bg-teal-50 blur-[120px] opacity-60" />

      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        className="max-w-3xl w-full text-center relative z-10"
      >
        <div className="inline-flex items-center justify-center p-5 bg-white rounded-3xl shadow-xl mb-10 border border-slate-50">
          <SafeIcon icon={FiIcons.FiHeart} className="text-5xl text-[#7C3AED]" />
        </div>
        
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-[900] text-[#4C1D95] tracking-tight mb-8 leading-[1.1]">
          Expert care advice for your <br className="hidden sm:block" />
          <span className="text-[#14B8A6]">dementia journey.</span>
        </h1>
        
        <p className="text-xl sm:text-2xl text-slate-500 mb-12 max-w-2xl mx-auto leading-relaxed font-medium">
          Answer a few questions to understand your funding rights and build a care profile for our experts to review.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button 
            onClick={onStart}
            className="btn-primary text-xl px-10 py-5 w-full sm:w-auto shadow-xl hover:shadow-purple-200"
          >
            Start Funding Guide
            <SafeIcon icon={FiIcons.FiArrowRight} className="ml-2" />
          </button>
          
          <a 
            href="https://memovo.co.uk"
            className="btn-secondary text-xl px-10 py-5 w-full sm:w-auto"
          >
            Back to Website
          </a>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-50 flex flex-wrap items-center justify-center gap-8 text-sm font-bold text-slate-400 uppercase tracking-widest">
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiIcons.FiClock} className="text-teal-500" />
            2 Minute Assessment
          </div>
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiIcons.FiShield} className="text-purple-500" />
            Secure & Confidential
          </div>
          <div className="flex items-center gap-2">
            <SafeIcon icon={FiIcons.FiCheckCircle} className="text-[#7C3AED]" />
            UK Funding Standards
          </div>
        </div>
      </motion.div>
    </div>
  );
}